module.exports = __webpack_public_path__ + "static/media/logo.feb4aa0a.png";